export interface SchemaValidationCollectionConfiguration {
    disabled?: boolean;
    schema: string; // JSON Schema as string
}
